import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from '@core/layout/layout.component';
import { AccessDeniedComponent } from '@core/pages/access-denied/access-denied.component';
import { PageNotFoundComponent } from '@core/pages/page-not-found/page-not-found.component';
import { ServerErrorComponent } from '@core/pages/server-error/server-error.component';

import { LoginComponent } from '@auth/components/login/login.component';
import { PERMISSIONS } from '@auth/permissions';
import { AuthGuard, PermissionGuard } from '@auth/services';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },

  {
    path: 'login',
    component: LoginComponent,
  },

  {
    path: 'access-denied',
    component: LayoutComponent,
    data: {
      requiredPermissions: [],
      breadcrumb: { label: 'core.breadcrumbs.errors.access_denied.label' },
    },
    children: [
      {
        path: '',
        component: AccessDeniedComponent,
      },
    ],
  },

  {
    path: 'page-not-found',
    component: LayoutComponent,
    data: {
      requiredPermissions: [],
      breadcrumb: { label: 'core.breadcrumbs.errors.page_not_found.label' },
    },
    children: [
      {
        path: '',
        component: PageNotFoundComponent,
      },
    ],
  },

  {
    path: 'exception',
    component: LayoutComponent,
    data: {
      requiredPermissions: [],
      breadcrumb: { label: 'core.breadcrumbs.errors.server_error.label' },
    },
    children: [
      {
        path: '',
        component: ServerErrorComponent,
      },
    ],
  },

  {
    path: 'admin',
    data: {
      requiredPermissions: [PERMISSIONS.WSADMIN],
      breadcrumb: { label: 'core.breadcrumbs.admin.root.label' },
      animation: 'admin',
    },
    component: LayoutComponent,
    loadChildren: () => import('@admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'home',
    data: {
      requiredPermissions: [],
      breadcrumb: { label: 'core.breadcrumbs.home.root.label' },
      animation: 'home',
    },
    component: LayoutComponent,
    loadChildren: () => import('@home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'orders',
    data: {
      requiredPermissions: [PERMISSIONS.WSINVINQUIRE],
      breadcrumb: { label: 'core.breadcrumbs.order.root.label' },
      animation: 'orders',
    },
    component: LayoutComponent,
    loadChildren: () => import('@order/order.module').then((m) => m.OrderModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    data: {
      requiredPermissions: [PERMISSIONS.WSREPORTS],
      breadcrumb: { label: 'core.breadcrumbs.report.root.label' },
      animation: 'reports',
    },
    component: LayoutComponent,
    loadChildren: () => import('@report/report.module').then((m) => m.ReportModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'user',
    data: {
      requiredPermissions: [PERMISSIONS.WSINVINQUIRE],
      breadcrumb: { label: 'core.breadcrumbs.user.root.label' },
      animation: 'user',
    },
    component: LayoutComponent,
    loadChildren: () => import('@user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: 'inventory',
    data: {
      requiredPermissions: [],
      breadcrumb: { label: 'core.breadcrumbs.inventory.root.label' },
      animation: 'inventory',
    },
    component: LayoutComponent,
    loadChildren: () => import('@inventory/inventory.module').then((m) => m.InventoryModule),
    canActivate: [AuthGuard, PermissionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
